module.exports = __webpack_public_path__ + "static/media/kp.a9f988e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/kp.svg
// module id = 166
// module chunks = 0